enum ProvidedServices {
  PricingService,
  GeoService,
  QuoteService,
  PollService,
}

export default ProvidedServices;
